import { createContext } from 'react';
import { configure } from 'mobx';
import LoginStore from './loginStore';
import TimesheetStore from './timesheetStore';
import UsersAdminStore from './usersAdminStore';
import ActivitiesStore from './activitiesStore';
import ProjectsStore from './projectsStore';
import EmailTemplatesStore from './emailTemplatesStore';
import CompaniesStore from './companiesStore';
import ClientsStore from './clientsStore';
import AppStore from './appStore';
import UtilsStore from './utilsStore';
import InvoiceStore from './invoiceStore';
import CurrenciesStore from './currenciesStore';
import FileStore from './fileStore';
import VatStore from './vatStore';
import WinbizStore from './winbizStore';
import RateStore from './rateStore';
import PackageExpenseStore from './packageExpenseStore';
import CountryCurrencyStore from './countryCurrencyStore';
import ExpenseWithCostsStore from './expenseWithCostsStore';
import InternalExpensesSummaryStore from './internalExpensesSummaryStore';
import React from "react";
import ExpenseVatStore from './expenseVatStore';
import ExpensesWithPakageFormStore from './expensesWithPakageFormStore';
import ExpensesWithCostsFormStore from './ExpensesWithCosts/expensesWithCostsFormStore';
import BilledExpensesFormStore from './billedExpenseFormStore';

configure({ enforceActions: 'always' });

export class RootStore {

    loginStore;
    timesheetStore;
    usersAdminStore;
    appStore;
    activitiesStore;
    projectsStore;
    templatesStore;
    companiesStore;
    clientsStore;
    invoiceStore;
    currenciesStore;
    fileStore;
    vatStore;
    winbizStore;
    rateStore;
    packageExpenseStore;
    countryCurrencyStore;
    expenseWithCostsStore;
    expensesWithPakageFormStore;
    expensesWithCostsFormStore;
    billedExpensesFormStore;
    
    constructor() {
        this.loginStore = new LoginStore(this);
        this.timesheetStore = new TimesheetStore(this);
        this.usersAdminStore = new UsersAdminStore(this);
        this.appStore = new AppStore(this);
        this.activitiesStore = new ActivitiesStore(this);
        this.projectsStore = new ProjectsStore(this);
        this.templatesStore = new EmailTemplatesStore(this);
        this.companiesStore = new CompaniesStore(this);
        this.clientsStore = new ClientsStore(this);
        this.utilsStore = new UtilsStore(this);
        this.invoiceStore = new InvoiceStore(this);
        this.currenciesStore = new CurrenciesStore(this);
        this.fileStore = new FileStore(this);
        this.vatStore = new VatStore(this);
        this.winbizStore = new WinbizStore(this);
        this.rateStore = new RateStore(this);
        this.packageExpenseStore = new PackageExpenseStore(this);
        this.countryCurrencyStore = new CountryCurrencyStore(this);
        this.expenseWithCostsStore = new ExpenseWithCostsStore(this);
        this.expenseVatStore = new ExpenseVatStore(this);
        this.internalExpensesSummaryStore = new InternalExpensesSummaryStore(this);
        this.expensesWithPakageFormStore = new ExpensesWithPakageFormStore(this);
        this.expensesWithCostsFormStore = new ExpensesWithCostsFormStore(this);
        this.billedExpensesFormStore = new BilledExpensesFormStore(this);
        
    }
}

const RootStoreContext = createContext(new RootStore());
export const useStores = () => React.useContext(RootStoreContext);
